import type { IconElement } from '@watershed/icons/Icon';
import CodeIcon from '@watershed/icons/components/Code';
import DocumentIcon from '@watershed/icons/components/Document';
import DocumentCsv16Icon from '@watershed/icons/components/DocumentCsv16';
import DocumentImage16Icon from '@watershed/icons/components/DocumentImage16';

export type FileTypeIcon =
  | 'pdf'
  | 'markdown'
  | 'text'
  | 'code'
  | 'image'
  | 'spreadsheet'
  | 'unknown';

const CODE_EXTENSIONS = new Set([
  'js',
  'jsx',
  'ts',
  'tsx',
  'mjs',
  'cjs',
  'py',
  'pyi',
  'pyw',
  'html',
  'htm',
  'css',
  'scss',
  'sass',
  'less',
  'json',
  'yaml',
  'yml',
  'toml',
  'xml',
  'ini',
  'env',
  'sh',
  'bash',
  'zsh',
  'fish',
  'bat',
  'ps1',
  'sql',
  'java',
  'kt',
  'scala',
  'go',
  'rs',
  'rb',
  'php',
  'swift',
  'c',
  'cpp',
  'h',
  'hpp',
  'cs',
  'r',
  'lua',
  'pl',
  'pm',
]);

export function getFileExtension(filename: string): string | null {
  const lastDotIndex = filename.lastIndexOf('.');
  if (lastDotIndex === -1 || lastDotIndex === filename.length - 1) {
    return null;
  }

  return filename.slice(lastDotIndex + 1).toLowerCase();
}

export function getFileType(filename: string): FileTypeIcon {
  const ext = getFileExtension(filename);
  if (!ext) return 'unknown';

  switch (ext) {
    case 'pdf':
      return 'pdf';
    case 'md':
      return 'markdown';
    case 'txt':
    case 'log':
      return 'text';
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'webp':
    case 'svg':
      return 'image';
    case 'csv':
    case 'xlsx':
    case 'xls':
      return 'spreadsheet';
    default:
      if (CODE_EXTENSIONS.has(ext)) {
        return 'code';
      }
      return 'unknown';
  }
}

export function getFileTypeIcon(filename: string): IconElement {
  switch (getFileType(filename)) {
    case 'spreadsheet':
      return DocumentCsv16Icon;
    case 'image':
      return DocumentImage16Icon;
    case 'code':
      return CodeIcon;
    default:
      return DocumentIcon;
  }
}
